import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { StatusFilter } from '../local-types/StatusFilter';

@Component({
  selector: 'app-status-filter',
  templateUrl: './status-filter.component.html',
  styleUrls: ['./status-filter.component.scss']
})
export class StatusFilterComponent {
  @Input() public showIcons = true;
  @Output() public selectionChanged = new EventEmitter<string[]>();
  
  public displayedColumns: string[] = ['select'];
  public dataSource = new MatTableDataSource<StatusFilter>();
  public selection = new SelectionModel<string>(true, []);

  private items$: Observable<StatusFilter[]> = new Observable<StatusFilter[]>();
  @Input()
  public get items(): Observable<StatusFilter[]> { return this.items$; }
  public set items(value: Observable<StatusFilter[]>) {
    this.items$ = value;
    if (this.items$) {
      this.items$.subscribe((items: StatusFilter[]) => {
        this.dataSource.data = items.sort((a, b) => a.name.localeCompare(b.name));
        this.dataSource.filterPredicate = this.filterData;
        this.verifyShowIcons();
      });
    }
  }

  public verifyShowIcons(): void {
    this.displayedColumns = ['select'];
    if (this.showIcons) {
      this.displayedColumns.push('icon');
    }
    this.displayedColumns.push('name');
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row.name));
    }
    this.selectionChanged.emit(this.selection.selected);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterData(data: any, filter: string): boolean {
    const nameColumn = 'name';
    if (!filter || !data) {
      return true;
    }

    return data[nameColumn].toLowerCase().indexOf(filter.toLowerCase()) !== -1;
  }

  public hasFilterSelected(): boolean {
    return this.selection && this.selection.selected && this.selection.selected.length > 0;
  }

  public clearFilters(): void {
    this.selection = new SelectionModel<string>(true, []);
    this.selectionChanged.emit(this.selection.selected);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public changeSelection(event: any, row: any): void {
    this.selection.toggle(row);
    this.selectionChanged.emit(this.selection.selected);
  }
}
